import React, {useMemo} from "react";
import {Helmet} from "react-helmet";

import StakingManager from "./Manager/StakingManager";
import Stats from "./Stats/Stats";
import Holdings from "./Holding/Holdings";
import StakedInfo from "./Info/StakedInfo";
import Locks from "./Locks/Locks";
import {useEthereum} from "../../EthereumContext";
import Account from "../Account/Account";
import useResize from "../../hooks/useResize";
import './style.scss';

function Staking() {
    const {account} = useEthereum();
    const { windowWidth } = useResize();
    const mobileView = useMemo(() => windowWidth <= 600, [windowWidth]);

    return (
        <div className="staking">
            <Helmet>
                <title>Staking - Roobee DAO</title>
            </Helmet>
            <div className="staking-title">
                <h2>Staking</h2>
                { mobileView ? null : <Account/> }
            </div>
            <div className="staking-wrapper_manager">
                <StakingManager />
            </div>
            <div className="staking-inner">
                <div className="staking-wrapper_stats">
                    <Stats />
                </div>
                <div className="staking-wrapper_holding">
                    <Holdings />
                </div>
            </div>
            <div className="staking-wrapper_info">
                <StakedInfo />
            </div>
            {account &&
                <div className="staking-wrapper_locks">
                    <Locks />
                </div>
            }
        </div>
    );
}

export default Staking;
